// extracted by mini-css-extract-plugin
export var postContainer = "category-module--postContainer--VxSLv";
export var suggestedPosts = "category-module--suggestedPosts--X-spD";
export var downState = "category-module--downState--N-xJF";
export var paginationButtonContainer = "category-module--paginationButtonContainer--g6K8b";
export var backAndForthRight = "category-module--backAndForthRight--jc06g";
export var wobbleRightAndLeft = "category-module--wobbleRightAndLeft--HwYfK";
export var animateBg = "category-module--animateBg--QAT5r";